// exporting most common css classes
const classes = {
  AUTH_FLOW_WRAPPER: 'auth-flow-wrapper',
  LOGIN_WRAPPER: 'login-wrapper',
  TEXT_FIELD_COMPLETED: 'text-field-completed',
  TEXT_FIELD_FAILED: 'text-field-failed',
  PAGE_OVERLAY: 'page-overlay',
};
export default classes;



// WEBPACK FOOTER //
// ./src/utils/classes.js